/* ============================================
   TRADUZIONI ITALIANE
   ============================================ */

export const it = {
  // Stati della partita
  matchStates: {
    notStarted: 'Non iniziato',
    firstHalf: '1° tempo',
    halfTime: 'Intervallo',
    secondHalf: '2° tempo',
    extraTimeFirstHalf: 'Supplementari 1° tempo',
    extraTimeHalfTime: 'Pausa supplementari',
    extraTimeSecondHalf: 'Supplementari 2° tempo',
    penalties: 'Rigori',
    finished: 'Finito',
    postponed: 'Rinviato',
    cancelled: 'Annullato',
    interrupted: 'Interrotto',
  },

  // Eventi
  events: {
    goal: 'Gol',
    yellowCard: 'Cartellino giallo',
    redCard: 'Cartellino rosso',
    substitution: 'Sostituzione',
    corner: 'Calcio d\'angolo',
    freeKick: 'Calcio di punizione',
    penalty: 'Rigore',
    offside: 'Fuorigioco',
    injury: 'Infortunio',
    var: 'VAR',
    shotOnTarget: 'Tiro in porta',
    shotOffTarget: 'Tiro fuori',
    throwin: 'Rimessa laterale',
    dangerousAttack: 'Attacco pericoloso',
    attack: 'Attacco',
    possession: 'Possesso',
    sixMeters: 'Area dei 6 metri',
    goalKick: 'Calcio di rinvio',
    blockedShot: 'Tiro bloccato',
    penaltyUnconfirmed: 'Rigore (da confermare)',
    penaltyMissed: 'Rigore sbagliato',
    goalNotification: 'Notifica gol',
    kickoff: 'Calcio d\'inizio',
    secondHalfKickoff: 'Calcio d\'inizio 2° tempo',
    ballLost: 'Palla persa',
    ballRecovered: 'Palla recuperata',
    ownGoal: 'Autogol',
    matchStart: 'Inizio',
    matchEnd: 'Fine',
    halfTimeScore: 'Risultato intervallo',
    cardConfirmed: 'Cartellino confermato',
    extraTimeEnded: 'Supplementari terminati',
    penaltyEnded: 'Rigore terminato',
    penaltyShootout: 'Rigori (sequenza)',
    penaltyShootoutMissed: 'Rigore sbagliato (sequenza)',
  },

  // Indicatori di possesso
  possession: {
    home: 'Possesso casa',
    away: 'Possesso trasferta',
    attack: 'Attacco',
    dangerousAttack: 'Attacco pericoloso',
  },

  // Interfaccia
  ui: {
    home: 'Casa',
    away: 'Trasferta',
    connected: 'Connesso',
    disconnected: 'Disconnesso',
    connecting: 'Connessione...',
    loading: 'Caricamento...',
    noMatch: 'Nessuna partita selezionata',
    selectMatch: 'Seleziona partita',
  },

  // Tempo aggiuntivo
  addedTime: {
    label: 'Recupero',
    minute: 'min',
    minutes: 'min',
  },

  // Notifiche
  notifications: {
    matchStarted: 'Inizio della partita',
    matchEnded: 'La partita è finita',
    halfTimeStarted: 'Intervallo',
    secondHalfStarted: 'Ripresa della partita',
    matchAboutToStart: 'La partita sta per iniziare',
    matchAboutToResume: 'La partita sta per riprendere',
    penaltiesInProgress: 'La sequenza è in corso',
    // Notifiche eventi centrati
    kickoffTitle: 'Calcio d\'inizio',
    kickoffSubtitle: 'La partita è iniziata!',
    goalTitle: 'Gol! gol! gol!',
    yellowCardTitle: 'Cartellino giallo',
    yellowCardSubtitle: 'Un giocatore ha ricevuto un cartellino giallo',
    redCardTitle: 'Cartellino rosso',
    redCardSubtitle: 'Un giocatore ha ricevuto un cartellino rosso',
    injuryTitle: 'Infortunio',
    injurySubtitle: 'Un giocatore è infortunato',
    substitutionTitle: 'Sostituzione',
    substitutionSubtitle: 'Cambio in corso',
    varTitle: 'VAR in corso',
    varSubtitle: 'L\'arbitro prenderà una decisione',
    varCancelledTitle: 'Gol annullato',
    varCancelledSubtitle: 'Il gol è stato annullato dal VAR',
    addedTimeTitle: 'Recupero',
    addedTimeSubtitle: 'Si giocheranno minuti aggiuntivi!',
  },

  // Indicatori di campo (MAIUSCOLE)
  fieldIndicators: {
    possession: 'POSSESSO',
    attack: 'ATTACCO',
    dangerousAttack: 'ATTACCO PERICOLOSO',
    throwin: 'RIMESSA LATERALE',
    freeKick: 'CALCIO DI PUNIZIONE',
    dangerousFreeKick: 'CALCIO DI PUNIZIONE PERICOLOSO',
    corner: 'CALCIO D\'ANGOLO',
    goalKick: 'CALCIO DI RINVIO',
    penalty: 'RIGORE',
    shotOnTarget: 'TIRO IN PORTA',
    shotOffTarget: 'TIRO FUORI',
    offside: 'FUORIGIOCO',
    ballLost: 'PALLA PERSA',
  },

  // Conto alla rovescia
  countdown: {
    hours: 'H',
    minutes: 'MIN',
    seconds: 'SEC',
  },

  // Controlli
  controls: {
    openRadar: 'Apri Radar',
    reload: 'Ricarica',
    date: 'Data',
    match: 'Partita',
    delay: 'Ritardo (secondi)',
    fieldLength: 'Lunghezza (px)',
    fieldWidth: 'Larghezza (px)',
    fieldColor: 'Colore campo',
    language: 'Lingua',
    connectedStatus: 'Connesso',
    disconnectedStatus: 'Non connesso',
  },
};

